module.exports = __webpack_public_path__ + "img/01.ce4f05e2.jpg";